import * as React from 'react';
import { createPortal } from 'react-dom';
import { WuiTable as _WuiTable } from '../../components';
import { replaceRenderFunction } from './util';
class CatchErrors extends React.Component {
    static getDerivedStateFromError(error) {
        // Update state for next render
        return { hasError: error };
    }
    componentDidCatch(...args) {
        console.warn(...args);
    }
    render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    }
}
/**
 * Higher order component that replaces the render functions for custom templates.
 */
export const WuiTable = React.forwardRef((props, ref) => {
    const [portalChildren, setPortalChildren] = React.useState({});
    const columnTemplates = React.useMemo(() => {
        const ret = {};
        for (const key in props.columnTemplates) {
            const newFn = replaceRenderFunction(props.columnTemplates[key], (componentType, el, args, id) => {
                const component = React.createElement(componentType, { record: args && args[0] });
                // eslint-disable-next-line react/no-children-prop
                const portal = createPortal(React.createElement(CatchErrors, { children: component }), el);
                setPortalChildren((state) => ({ ...state, [`col.${key}.${id}`]: portal }));
            });
            if (newFn) {
                ret[key] = newFn;
            }
        }
        return ret;
    }, [props.columnTemplates, setPortalChildren]);
    const hoverActionsTemplate = React.useMemo(() => replaceRenderFunction(props.hoverActionsTemplate, (componentType, el, args, id) => {
        const component = React.createElement(componentType, { record: args && args[0] });
        // eslint-disable-next-line react/no-children-prop
        const portal = createPortal(React.createElement(CatchErrors, { children: component }), el);
        setPortalChildren((state) => ({ ...state, [`hov.${id}`]: portal }));
    }), [props.hoverActionsTemplate, setPortalChildren]);
    return (React.createElement(_WuiTable, { ...props, columnTemplates: columnTemplates, hoverActionsTemplate: hoverActionsTemplate, ref: ref },
        props.children,
        Object.values(portalChildren)));
});
